<template>
  <div class="introduce-product-detail" ref="introduceProductDetail">
    <img
      ref="detailImg"
      style="display: inline-block !important; max-width: 100%; height: auto;"
      src="@/assets/images/product/productDetail.png"
      @click="handleClick"
    />
    <svg class="overlay" ref="overlay" :viewBox="`0 0 ${naturalW} ${naturalH}`" xmlns="http://www.w3.org/2000/svg">
      <g v-for="(p, i) in points" :key="i" class="point-group">
        <!-- 波浪涟漪 -->
        <circle v-for="n in 3" :key="n" :cx="p.x" :cy="p.y" r="8" fill="none" stroke="#00acf8" stroke-width="4" class="ripple">
          <animate attributeName="r" values="4;16" dur="2s" :begin="`${(n - 1) * 0.5}s`" repeatCount="indefinite" />
          <animate attributeName="stroke-opacity" values="1;0" dur="2s" :begin="`${(n - 1) * 0.5}s`" repeatCount="indefinite" />
        </circle>

        <!-- 实心圆点 -->
        <circle :cx="p.x" :cy="p.y" r="8" fill="#00acf8" class="dot" />

        <!-- 折线 -->
        <polyline
          :points="`${p.x},${p.y} ${p.x},${p.y + p.vDir} ${p.x + p.hDir},${p.y + p.vDir}`"
          fill="none"
          stroke="#00acf8"
          stroke-width="clamp(2px, 0.2vw, 3px)"
          class="line"
        />

        <!-- 文字 -->
        <text
          v-if="p.text"
          :x="p.x + p.hDir + (p.hDir >= 0 ? 5 : -5)"
          :y="p.y + p.vDir"
          fill="#00acf8"
          alignment-baseline="middle"
          :text-anchor="p.hDir >= 0 ? 'start' : 'end'"
          class="label"
        >{{ p.text }}</text>
      </g>
    </svg>
  </div>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  data() {
    return {
      naturalW: 0,
      naturalH: 0,
      points: [
        { x: 1200, y: 992, vDir: -180, hDir: -280, text: this.$t('message.productSystemDetailSideNote1') },
        { x: 1227, y: 1331, vDir: 130, hDir: -550, text: this.$t('message.productSystemDetailSideNote2') },
        { x: 1694, y: 1293, vDir: 400, hDir: 1200, text: this.$t('message.productSystemDetailSideNote3') },
        { x: 2560, y: 972, vDir: 0, hDir: 300, text: this.$t('message.productSystemDetailSideNote4') },
        { x: 2392, y: 820, vDir: -120, hDir: 420, text: this.$t('message.productSystemDetailSideNote5') },
        { x: 2278, y: 820, vDir: -120, hDir: 420, text: '' }
      ]
    }
  },
  methods: {
    handleClick(e) {
      const img = this.$refs.detailImg
      const rect = img.getBoundingClientRect()
      const offsetX = e.clientX - rect.left
      const offsetY = e.clientY - rect.top
      const x = (offsetX / rect.width) * img.naturalWidth
      const y = (offsetY / rect.height) * img.naturalHeight
      console.log('点击坐标:', { x, y })
    },

    setupInitialState(svg) {
      const groups = svg.querySelectorAll('.point-group')
      groups.forEach(group => {
        const dot = group.querySelector('.dot')
        const line = group.querySelector('.line')
        const label = group.querySelector('.label')
        const ripples = group.querySelectorAll('.ripple')

        // ✅ 修正圆点横移问题
        gsap.set(dot, { scale: 0, transformOrigin: '50% 50%' })

        if (label) {
          const anchor = label.getAttribute('text-anchor')
          const xOffset = anchor === 'start' ? 10 : -10
          gsap.set(label, { opacity: 0, x: xOffset })
        }

        gsap.set(ripples, { opacity: 0 })

        try {
          const len = line.getTotalLength()
          line.style.strokeDasharray = len
          line.style.strokeDashoffset = len
        } catch {
          line.style.strokeDasharray = 1000
          line.style.strokeDashoffset = 1000
        }
      })
    },

    createTimeline(container, svg) {
      const groups = svg.querySelectorAll('.point-group')
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: 'top center',
          end: 'bottom center',
          toggleActions: 'restart none none reset',
          onEnter: () => {
            this.setupInitialState(svg)
            tl.restart()
          },
          onEnterBack: () => {
            this.setupInitialState(svg)
            tl.restart()
          }
        }
      })

      groups.forEach(group => {
        const dot = group.querySelector('.dot')
        const line = group.querySelector('.line')
        const label = group.querySelector('.label')
        const ripples = group.querySelectorAll('.ripple')

        // 点
        tl.to(dot, { scale: 1, duration: 0.35, ease: 'back.out(1.4)' })

        // 线
        tl.to(line, { strokeDashoffset: 0, duration: 0.8, ease: 'power1.out' })

        // 字
        if (label) {
          tl.to(label, { opacity: 1, x: 0, duration: 0.35, ease: 'power1.out' }, '-=0.2')
        }

        // ✅ 在字出现后再显示波纹
        tl.to(ripples, { opacity: 1, duration: 0.05 }, '+=0.05')

        // 小间隔
        tl.to({}, { duration: 0.12 })
      })

      return tl
    },

    initGsapScrollAnimation() {
      const container = this.$refs.introduceProductDetail
      const svg = this.$refs.overlay
      if (!container || !svg) return
      this.setupInitialState(svg)
      this.createTimeline(container, svg)
    }
  },

  mounted() {
    const img = this.$refs.detailImg
    img.onload = () => {
      this.naturalW = img.naturalWidth
      this.naturalH = img.naturalHeight
      this.$nextTick(() => {
        this.initGsapScrollAnimation()
      })
    }
    if (img.complete && img.naturalWidth) {
      img.onload()
    }
  }
}
</script>

<style>
.introduce-product-detail {
  position: relative;
  display: inline-block;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.point-group .dot {
  transform-origin: 50% 50%;
}
.ripple {
  opacity: 0;
}
.label {
  font-family: 'D-DIN-PRO', 'Microsoft YaHei', sans-serif;
  font-size: 30px; /* ✅ 与网页字体完全一致 */
  fill: #00acf8;
  font-weight: 400;
  letter-spacing: 0.5px;
  /* text-shadow: 0 0 6px rgba(0, 172, 248, 0.6); */
}



</style>
